export default "__VITE_ASSET__CfKEVtR$__"